import { ApiBooking } from '@ibe/api';

class BookingRemoveItemEvent {
  booking: ApiBooking | null;

  items: Array<{ id: string }>;
}

export default BookingRemoveItemEvent;
